
const state = {
    popup_datas: "",
  };
  const getters = {
    popup_datas: state => state.popup_datas,
  };
  const mutations = {
    set_popup_datas(state, data) {
      state.popup_datas = data;
    },
  };
  const actions = {
    set_popup_datas({ commit }, data) {
      commit("set_popup_datas", data);
    }
  };
  export default {
    state,
    getters,
    mutations,
    actions
  };
  